import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { SecurityService } from '@connect-services/client/services/security.service';

export function notAuthenticatedGuard(): Promise<boolean> | boolean {
    const securityService = inject(SecurityService);
    const router = inject(Router);

    if (securityService.isAuthenticated()) {
        return router.navigate(['/']);
    }

    return true;
}
